import React, { useState, useEffect } from 'react';
import { Button, Modal } from 'react-bootstrap';
import 'react-toastify/dist/ReactToastify.css';

const Location = ({ show, onClose, lat, long }) => {

    const mapUrl = `https://maps.google.com/maps?q=${lat},${long}&z=15&output=embed`;
    
    return (
        <Modal show={show} size="lg">
            <div className="modal-content border border-red rounded-xxl">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title text-white">Call Location</h3>
                    <Button variant="" type="button" className="close px-6 py-2" data-dismiss="modal" onClick={onClose}>
                        <span className="text-white">×</span>
                    </Button>
                </div>
                <div className="modal-body">
                    <Modal.Body style={{ height: '400px' }}>
                        <iframe
                        width="100%"
                        height="100%"
                        frameBorder="0"
                        src={mapUrl}
                        allowFullScreen
                        />
                    </Modal.Body>
                </div>
            </div>
        </Modal>
    );
};

export default Location;
